/* ============================================================
   Size & Framing Guide — editorial layout built inside any
   <div data-sfg></div> (the Size & Framing Guide page content or the
   product tab). Recreated from the Claude Design export, using the
   theme fonts. Choose-your-finish cards double as the table filter;
   CM/IN toggle switches units. Self-contained (data + markup + styles).
   ============================================================ */
(function () {
  'use strict';

  // f: { cm, in } | null (Not available) | 'TBC'
  function P(name, aka, uc, ui, cc, ci, bc, bi) {
    return {
      name: name, aka: aka,
      unframed: { cm: uc, in: ui },
      classic: cc ? { cm: cc, in: ci } : null,
      box: bc === 'TBC' ? 'TBC' : (bc ? { cm: bc, in: bi } : null)
    };
  }

  var RECT = [
    P('Mini', 'A4', '21 × 29.7 cm', '8.3 × 11.7 in', '24 × 33 × 2 cm', '9.4 × 13 × 0.8 in', '24 × 33 × 3 cm', '9.4 × 13 × 1.2 in'),
    P('Small', 'A3', '29.7 × 42 cm', '11.7 × 16.5 in', '33 × 45.4 × 2 cm', '13 × 17.9 × 0.8 in', '33 × 45.4 × 3 cm', '13 × 17.9 × 1.2 in'),
    P('Medium', 'A2', '42 × 59.4 cm', '16.5 × 23.4 in', '45 × 62.4 × 2 cm', '17.7 × 24.6 × 0.8 in', '46 × 63.5 × 4.5 cm', '18.1 × 25 × 1.8 in'),
    P('Large', 'A1', '59.4 × 84.1 cm', '23.4 × 33.1 in', '62.4 × 87.1 × 2 cm', '24.6 × 34.3 × 0.8 in', '63.5 × 88 × 4.5 cm', '25 × 34.6 × 1.8 in'),
    P('X-Large', 'B1', '70.7 × 100 cm', '27.8 × 39.4 in', '73.7 × 103 × 2 cm', '29 × 40.6 × 0.8 in', '75 × 105 × 4.5 cm', '29.5 × 41.3 × 1.8 in'),
    P('Gallery', 'A0', '84.1 × 118.9 cm', '33.1 × 46.8 in', '87.2 × 122.1 × 3 cm', '34.3 × 48.1 × 1.2 in', '89 × 124 × 4.5 cm', '35 × 48.8 × 1.8 in'),
    P('Giant', '40 × 60"', '101.6 × 152.4 cm', '40 × 60 in', null, null, '106 × 157 × 4.5 cm', '41.7 × 61.8 × 1.8 in'),
    P('Epic', '50 × 75"', '127 × 190.5 cm', '50 × 75 in', null, null, 'TBC', 'TBC'),
    P('Statement', '60 × 90"', '152.4 × 228.6 cm', '60 × 90 in', null, null, 'TBC', 'TBC')
  ];
  var SQUARE = [
    P('Mini', '12 × 12"', '30.5 × 30.5 cm', '13.1 × 13.1 in', '33.5 × 33.5 × 2 cm', '13.2 × 13.2 × 0.8 in', '33.5 × 33.5 × 3 cm', '13.2 × 13.2 × 1.2 in'),
    P('Medium', '20 × 20"', '50.8 × 50.8 cm', '20.9 × 20.9 in', '54 × 54 × 2 cm', '21.3 × 21.3 × 0.8 in', '58 × 58 × 4.5 cm', '22.8 × 22.8 × 1.8 in'),
    P('Large', '28 × 28"', '71.1 × 71.1 cm', '28.8 × 28.8 in', '74 × 74 × 2 cm', '29.1 × 29.1 × 0.8 in', '78 × 78 × 4.5 cm', '30.7 × 30.7 × 1.8 in'),
    P('X-Large', '36 × 36"', '91.4 × 91.4 cm', '36 × 36 in', '94.5 × 94.5 × 3 cm', '37.2 × 37.2 × 1.2 in', '96 × 96 × 3 cm', '37.8 × 37.8 × 1.2 in'),
    P('Epic', '45 × 45"', '114.3 × 114.3 cm', '45 × 45 in', null, null, '118 × 118 × 4.5 cm', '46.5 × 46.5 × 1.8 in')
  ];

  var NAMES = { unframed: 'Unframed', classic: 'Classic Frame', box: 'Premium Shadow Box' };
  var NOTES = {
    unframed: 'Shipped rolled in a sturdy tube, protected by acid-free glassine. Dimensions shown are the paper size.',
    classic: 'A slim, modern profile — 2 cm deep, rising to 3 cm for X-Large & Gallery. Dimensions shown are the outer frame, glazed in premium acrylic.',
    box: 'A deeper profile with a spacer between art and acrylic for a floating effect. Dimensions shown are the outer frame.'
  };
  var CARD_DESC = {
    unframed: 'Rolled in a tube — ready for your framer.',
    classic: '2 × 2 cm profile — oak, black or white.',
    box: 'Deeper profile with a floating, spaced mount.'
  };
  // Default finish photos (merchant Files). Override per-card with
  // data-sfg-img-unframed / -classic / -box on the mount if needed.
  var DEFAULT_IMGS = {
    unframed: 'https://cdn.shopify.com/s/files/1/0253/9198/8832/files/Ilford_Paper_Close_Up.jpg?v=1783130489',
    classic: 'https://cdn.shopify.com/s/files/1/0253/9198/8832/files/Classic_Frame_Corner.jpg?v=1783130489',
    box: 'https://cdn.shopify.com/s/files/1/0253/9198/8832/files/Box_Frame_Corner.jpg?v=1783130489'
  };

  var CARD_VIS = {
    unframed: '<div class="sfg-vis"><div class="sfg-uf"><span></span></div></div>',
    classic: '<div class="sfg-vis"><div class="sfg-cl"><div class="sfg-cl-mat"><div class="sfg-cl-art"></div></div></div></div>',
    box: '<div class="sfg-vis"><div class="sfg-bx"><div class="sfg-bx-in"><div class="sfg-bx-art"></div></div></div></div>'
  };

  var CSS = '' +
    '.sfg{font-family:var(--text-font-family);color:#111111;max-width:1080px;margin:0 auto}' +
    '.sfg *{box-sizing:border-box}' +
    '.sfg-eyebrow{font-size:11px;letter-spacing:0.22em;text-transform:uppercase;color:#8A8680}' +
    '.sfg-intro{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:start;padding:8px 0 60px}' +
    '.sfg-intro h2{font-family:var(--heading-font-family);font-weight:400;font-size:40px;line-height:1.14;letter-spacing:-0.01em;margin:22px 0 0}' +
    '.sfg-intro p{font-size:15px;line-height:1.85;color:#55524D;margin:0 0 18px;max-width:46ch}' +
    '.sfg-intro p:last-child{margin-bottom:0}' +
    '.sfg-intro em{font-style:italic}' +
    '.sfg-finishes{border-top:1px solid #ECEAE6;padding-top:48px}' +
    '.sfg-cards{display:flex;gap:18px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;margin-top:22px;padding-bottom:2px}' +
    '.sfg-card{flex:1 1 264px;min-width:264px;scroll-snap-align:start;text-align:left;background:#fff;border:1px solid #E3E1DD;padding:0;cursor:pointer;font:inherit;color:inherit;display:flex;flex-direction:column;transition:border-color .15s ease}' +
    '.sfg-card:hover{border-color:#9C978E}' +
    '.sfg-card.is-active{border-color:#111111}' +
    '.sfg-vis{background:#F7F6F2;aspect-ratio:1/1;width:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}' +
    '.sfg-vis--img{background-size:cover;background-position:center;background-repeat:no-repeat}' +
    '.sfg-uf{width:84px;height:112px;background:#fff;border:1px solid #E3E1DD;box-shadow:0 12px 24px -15px rgba(17,17,17,.4);position:relative}' +
    '.sfg-uf span{position:absolute;inset:12px;background:#EDEAE4;display:block}' +
    '.sfg-cl{width:90px;height:116px;background:#1C1B19;padding:5px;box-shadow:0 14px 26px -15px rgba(17,17,17,.45)}' +
    '.sfg-cl-mat{background:#fff;padding:9px;height:100%}' +
    '.sfg-cl-art{background:#EDEAE4;height:100%}' +
    '.sfg-bx{width:96px;height:120px;background:#FBFAF8;border:1px solid #1C1B19;padding:14px;box-shadow:0 18px 32px -14px rgba(17,17,17,.5)}' +
    '.sfg-bx-in{background:#fff;height:100%;box-shadow:inset 0 0 0 1px #ECEAE6;display:flex;align-items:center;justify-content:center}' +
    '.sfg-bx-art{width:54%;height:62%;background:#EDEAE4;box-shadow:0 5px 10px -3px rgba(17,17,17,.35)}' +
    '.sfg-card-body{padding:18px 20px 20px}' +
    '.sfg-card-top{display:flex;justify-content:space-between;align-items:baseline}' +
    '.sfg-card-name{font-size:15px;font-weight:600}' +
    '.sfg-card-sel{font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#111111;opacity:0}' +
    '.sfg-card.is-active .sfg-card-sel{opacity:1}' +
    '.sfg-card-desc{font-size:13px;line-height:1.6;color:#55524D;margin-top:7px}' +
    '.sfg-table{border-top:1px solid #ECEAE6;margin-top:52px;padding-top:40px}' +
    '.sfg-table-head{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:8px}' +
    '.sfg-fname{font-family:var(--heading-font-family);font-size:30px;font-weight:400;line-height:1}' +
    '.sfg-unit{display:flex;border:1px solid rgba(0,0,0,0.16)}' +
    '.sfg-unit button{padding:11px 22px;background:#fff;color:#111;border:0;cursor:pointer;font-family:var(--text-font-family);font-size:11px;letter-spacing:0.14em;font-weight:600}' +
    '.sfg-unit button + button{border-left:1px solid rgba(0,0,0,0.16)}' +
    '.sfg-unit button.is-active{box-shadow:inset 0 0 0 1px #111111}' +
    '.sfg-note{font-size:13.5px;line-height:1.7;color:#8A8680;margin:0 0 36px;max-width:74ch}' +
    '.sfg-cols{display:grid;grid-template-columns:1fr 1fr;gap:0 64px}' +
    '.sfg-colhead{font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:#8A8680;padding-bottom:6px}' +
    '.sfg-row{display:grid;grid-template-columns:1fr auto;align-items:baseline;gap:20px;padding:16px 0;border-top:1px solid #ECEAE6}' +
    '.sfg-row-l{display:flex;align-items:baseline;gap:12px}' +
    '.sfg-row-name{font-size:15px;font-weight:600;color:#111111}' +
    '.sfg-row-aka{font-size:11px;letter-spacing:0.08em;text-transform:uppercase;color:#B0ABA2}' +
    '.sfg-row-dim{font-size:14px;white-space:nowrap;color:#111111}' +
    '.sfg-row-dim.is-na{color:#C4BFB6;font-style:italic}' +
    '.sfg-fine{border-top:1px solid #ECEAE6;padding-top:20px;margin-top:36px;font-size:12.5px;line-height:1.7;color:#B0ABA2}' +
    '.sfg-specs{display:grid;grid-template-columns:repeat(4,1fr);border-top:1px solid #111111;border-bottom:1px solid #ECEAE6;margin:56px 0 8px}' +
    '.sfg-spec{padding:24px 22px}' +
    '.sfg-spec:first-child{padding-left:0}' +
    '.sfg-spec:last-child{padding-right:0}' +
    '.sfg-spec + .sfg-spec{border-left:1px solid #ECEAE6}' +
    '.sfg-spec-l{font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:#8A8680;margin-bottom:9px}' +
    '.sfg-spec-v{font-size:13.5px;line-height:1.6;color:#111111}' +
    '@media(max-width:760px){' +
      '.sfg-intro{grid-template-columns:1fr;gap:16px;padding:2px 0 40px}' +
      '.sfg-intro h2{font-size:29px}' +
      '.sfg-finishes{padding-top:36px}' +
      '.sfg-cards{gap:14px;margin:18px -20px 0;padding:0 20px 4px}' +
      '.sfg-card{flex:0 0 78%;min-width:78%}' +
      '.sfg-table{margin-top:44px;padding-top:32px}' +
      '.sfg-table-head{gap:12px;align-items:center}' +
      '.sfg-fname{font-size:22px}' +
      '.sfg-unit button{padding:9px 16px}' +
      '.sfg-note{margin-bottom:28px}' +
      '.sfg-cols{grid-template-columns:1fr;gap:0}' +
      '.sfg-cols > div + div{margin-top:34px}' +
      '.sfg-fine{margin-top:28px}' +
      '.sfg-specs{grid-template-columns:1fr;margin:44px 0 8px}' +
      '.sfg-spec{padding:18px 0}' +
      '.sfg-spec + .sfg-spec{border-left:0;border-top:1px solid #ECEAE6}' +
    '}';

  function injectCss() {
    if (document.getElementById('sfg-css')) return;
    var s = document.createElement('style');
    s.id = 'sfg-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function rowHtml(s, framing, unit) {
    var f = s[framing], dim, na = false;
    if (!f) { dim = 'Not available'; na = true; }
    else if (f === 'TBC') { dim = 'Coming soon'; na = true; }
    else { dim = unit === 'cm' ? f.cm : f.in; }
    return '<div class="sfg-row"><div class="sfg-row-l">' +
      '<span class="sfg-row-name">' + s.name + '</span>' +
      '<span class="sfg-row-aka">' + s.aka + '</span></div>' +
      '<span class="sfg-row-dim' + (na ? ' is-na' : '') + '">' + dim + '</span></div>';
  }

  function cardHtml(id, active, imgs) {
    var vis = (imgs && imgs[id])
      ? '<div class="sfg-vis sfg-vis--img" style="background-image:url(\'' + imgs[id].replace(/'/g, '%27') + '\')"></div>'
      : CARD_VIS[id];
    return '<button type="button" class="sfg-card' + (active ? ' is-active' : '') + '" data-sfg-finish="' + id + '">' +
      vis +
      '<div class="sfg-card-body">' +
        '<div class="sfg-card-name">' + NAMES[id] + '</div>' +
        '<div class="sfg-card-desc">' + CARD_DESC[id] + '</div></div></button>';
  }

  function render(root, st) {
    var framing = st.framing, unit = st.unit;
    var depthNote = framing === 'unframed' ? '' : ' × depth';
    root.innerHTML =
      '<div class="sfg-intro">' +
        '<div><div class="sfg-eyebrow">Size &amp; framing</div>' +
        '<h2>Museum-grade prints, made to live with you for a lifetime.</h2></div>' +
        '<div><p>Every piece is printed on <em>Ilford archival matte art paper</em> — smooth with a faint tooth, museum-grade and fade-resistant. Ideal for both fine art and photography.</p>' +
        '<p>Unframed prints arrive rolled in a sturdy tube, wrapped in acid-free glassine. Framed prints come ready to hang — mounted on acid-free board and fitted with a steel wire.</p></div>' +
      '</div>' +
      '<div class="sfg-finishes"><div class="sfg-eyebrow">Choose your finish</div>' +
        '<div class="sfg-cards">' + cardHtml('unframed', framing === 'unframed', st.imgs) + cardHtml('classic', framing === 'classic', st.imgs) + cardHtml('box', framing === 'box', st.imgs) + '</div>' +
      '</div>' +
      '<div class="sfg-table">' +
        '<div class="sfg-table-head"><div class="sfg-fname">' + NAMES[framing] + '</div>' +
          '<div class="sfg-unit">' +
            '<button type="button" data-sfg-unit="cm" class="' + (unit === 'cm' ? 'is-active' : '') + '">CM</button>' +
            '<button type="button" data-sfg-unit="in" class="' + (unit === 'in' ? 'is-active' : '') + '">IN</button>' +
          '</div></div>' +
        '<p class="sfg-note">' + NOTES[framing] + '</p>' +
        '<div class="sfg-cols">' +
          '<div><div class="sfg-colhead">Portrait &amp; Landscape</div>' + RECT.map(function (s) { return rowHtml(s, framing, unit); }).join('') + '</div>' +
          '<div><div class="sfg-colhead">Square</div>' + SQUARE.map(function (s) { return rowHtml(s, framing, unit); }).join('') +
            '<div class="sfg-fine">Dimensions are given width × height' + depthNote + '. Colour and screen calibration may cause slight variation.</div></div>' +
        '</div>' +
      '</div>' +
      '<div class="sfg-specs">' +
        '<div class="sfg-spec"><div class="sfg-spec-l">Paper</div><div class="sfg-spec-v">Ilford archival matte — museum-grade &amp; fade-resistant.</div></div>' +
        '<div class="sfg-spec"><div class="sfg-spec-l">Glazing</div><div class="sfg-spec-v">2–3 mm premium acrylic. Non-reflective on request.</div></div>' +
        '<div class="sfg-spec"><div class="sfg-spec-l">Border</div><div class="sfg-spec-v">15% white margin, or edge-to-edge. Your choice.</div></div>' +
        '<div class="sfg-spec"><div class="sfg-spec-l">Frames</div><div class="sfg-spec-v">Australian oak, or Italian wood in black &amp; white.</div></div>' +
      '</div>';
  }

  function build(root) {
    if (root.__sfg) return;
    root.__sfg = true;
    var st = {
      framing: 'unframed',
      unit: 'cm',
      imgs: {
        unframed: root.getAttribute('data-sfg-img-unframed') || DEFAULT_IMGS.unframed,
        classic: root.getAttribute('data-sfg-img-classic') || DEFAULT_IMGS.classic,
        box: root.getAttribute('data-sfg-img-box') || DEFAULT_IMGS.box
      }
    };
    render(root, st);
    root.addEventListener('click', function (e) {
      var f = e.target.closest && e.target.closest('[data-sfg-finish]');
      var u = e.target.closest && e.target.closest('[data-sfg-unit]');
      if (f) {
        st.framing = f.getAttribute('data-sfg-finish');
        render(root, st);
        // slide the newly-selected card into view in the scroll strip (mobile)
        var active = root.querySelector('.sfg-card.is-active');
        if (active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else if (u) {
        st.unit = u.getAttribute('data-sfg-unit');
        render(root, st);
      }
    });
  }

  function init() {
    var mounts = document.querySelectorAll('[data-sfg]');
    if (!mounts.length) return;
    injectCss();
    mounts.forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('click', function () { setTimeout(init, 0); });
})();
